import styled from 'styled-components';

const ListItem = ({ children, onClick }) => {
  return <Item onClick={onClick}>{children}</Item>;
};

export default ListItem;

const Item = styled.li`
  width: 100%;
  background-color: ${({ selected }) =>
    props =>
      selected === true
        ? props.theme.listItem.selected.backgroundColor
        : props.theme.listItem.backgroundColor};
  padding: ${props => props.theme.listItem.padding ?? '0.5rem'};
  font-size: ${props => props.theme.listItem.fontSize ?? '1rem'};
  color: ${({ selected }) =>
    props =>
      selected === true
        ? props.theme.listItem.fontColorSelected
        : props.theme.listItem.fontSelected ?? 'default'};
  line-height: 1.3;
  border-bottom: ${props => props.theme.listItem.borderBottom};
  border-left: ${props => props.theme.listItem.borderLeft};
  border-right: ${props => props.theme.listItem.borderRight};
  border-top: ${props => props.theme.listItem.borderTop};
  border-radius: ${props =>
    props.theme.listItem.borderRadius
      ? props.theme.listItem.borderRadius
      : '0'};
  cursor: pointer;
  transition: 0.3s ease;
  user-select: none;
  box-shadow: ${({ selected }) =>
    selected === true ? '0 0.125rem 0.62rem rgba(0, 0, 0, 0.2)' : 'none'};

  h4 {
    font-size: ${props => props.theme.listItem.headerFontSize};
    font-weight: ${props => props.theme.listItem.headerFontWeight};
    color: ${({ selected }) =>
      selected === true
        ? props => props.theme.listItem.headerColor
        : props => props.theme.listItem.headerFontColor};
    line-height: '1.3';
  }

  &:hover {
    background-color: ${props => props.theme.listItem.hover.backgroundColor};
    border-color: ${props => props.theme.listItem.hover.borderColor};
    box-shadow: ${props => props.theme.listItem.hover.boxShadow};
  }
`;
